
//Components
import AContact from "../components/AContact.js"
import Navbar from "../components/Navbar.js"

//Images
import InfoQuienesSomos from "../components/InfoQuienesSomos.js"

export default function QuienesSomos () {

    return (
        <div>
            <AContact />
            <Navbar />
            <InfoQuienesSomos />
        </div>
    )
}